/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type { MouseEventHandler } from "react";
import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import ColumnViewChart from "./columnChart";
import ATMServicesGrid from "./atmServicesGrid";
import DonutViewChart from "./piechart";
import MultiSeriesDonutViewChart from "./radialBarChart";
import RadialGaugeViewChart from "./radialGaugeChart";
import BarViewChart from "./barChart";
import VanCashLimitViewChart from "./lineChart";
import ServicesCompletionViewChart from "./progressChart";
import ProcessedCashGrid from "./processedCashGrid";
import VaultStatusGrid from "./vaultStatusGrid";
import VansStatusGrid from "./vansStatusGrid";
import { showToast } from "utils/helper";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
} from "@repo/ui";
import Layout from "components/layout";
import {
  useGetCashCenters,
  useGetCurrenciesList,
  useGetCustomers,
  useGetDispatchedRoutes,
} from "utils/apis/lookups.api";
import { UserContext } from "utils/reducers/user";
import {
  useGetAtmProcessedCash,
  useGetAtmServices,
  useGetCitProcessedCash,
  useGetCitServices,
  useGetDispatchedVans,
  useGetEndOfDayProgress,
  useGetVansStatus,
  useGetVaultStatus,
} from "utils/apis/dashboard.api";
import { format } from "date-fns";
import { List } from "lucide-react";

const currentDate = new Date();

const monthFirstDate = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1
);

const locationTypes = [
  { label: "ATM", value: "ATM" },
  { label: "CDM", value: "CDM" },
];

const serviceTypes = [
  { label: "VIP Collections", value: "VIP Collections" },
  { label: "Branch Collections", value: "Branch Collections" },
  { label: "Central Bank Collections", value: "Central Bank Collections" },
  { label: "Hub Collections", value: "Hub Collections" },
  { label: "VIP Deliveries", value: "VIP Deliveries" },
  { label: "Branch Deliveries", value: "Branch Deliveries" },
  { label: "Central Bank Deliveries", value: "Central Bank Deliveries" },
  { label: "Hub Deliveries", value: "Hub Deliveries" },
];

function SMTDashboardPage() {
  const user = useContext(UserContext);
  const [ddlCustomers, setDdlCustomers] = useState("");
  const [ddlCashCenters, setDdlCashCenters] = useState(user?.CashCenterId);
  const [ddlCurrencies, setDdlCurrencies] = useState("");
  const [routeNo, setRouteNo] = useState("");
  const [ddlLocationTypes, setDdlLocationTypes] = useState("");
  const [ddlServiceTypes, setDdlServiceTypes] = useState("");
  const [operationDate, setOperationDate] = useState(currentDate);
  const [fromDate, setFromDate] = useState<Date>(monthFirstDate);
  const [toDate, setToDate] = useState<Date>(currentDate);

  const [period, setPeriod] = useState<
    "Today" | "Flex Period" | "Last Week" | "Last Month"
  >("Today");
  const [showFlexPeriod, setShowFlexPeriod] = useState(false);

  const [showAtmServiceChart, setShowAtmServiceChart] = useState(true);

  const [showCitServiceChart, setShowCitServiceChart] = useState(true);

  const [citServicesHealth, setCitServicesHealth] = useState("0");
  const [atmServicesHealth, setAtmServicesHealth] = useState("0");

  const [atmNotes, setAtmNotes] = useState(0);

  const [showCitCashChart, setShowCitCashChart] = useState(true);
  const [citCashProcessedOrders, setCitCashProcessedOrders] = useState(0);
  const [citProcessedCashGrid, setCitProcessedCashGrid] = useState([]);
  const [citNotes, setCitNotes] = useState(0);

  const [vaultStatus, setVaultStatus] = useState<any>([]);
  const [showVaultStatusChart, setShowVaultStatusChart] = useState(true);

  const [showVansChart, setShowVansChart] = useState(true);

  const [vansCashLimit, setVansCashLimit] = useState(0);
  const [dispatchedVans, setDispatchedVans] = useState([]);

  const { data: cashCenterList } = useGetCashCenters();
  const { data: customerList } = useGetCustomers();
  const { data: currencyList } = useGetCurrenciesList();
  const { data: routes = [] } = useGetDispatchedRoutes({
    cashCenterId: ddlCashCenters,
    operationDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
  });

  const { data: atmServices = [] } = useGetAtmServices({
    period,
    routeNo,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    locationType: ddlLocationTypes,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
    fromDate:
      period === "Flex Period"
        ? format(fromDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
    toDate:
      period === "Flex Period"
        ? format(toDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
  });

  const { data: atmProcessedCash } = useGetAtmProcessedCash({
    period,
    routeNo,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    locationType: ddlLocationTypes,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
    fromDate:
      period === "Flex Period"
        ? format(fromDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
    toDate:
      period === "Flex Period"
        ? format(toDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
  });

  const { data: citServices = [] } = useGetCitServices({
    period,
    routeNo,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    serviceType: ddlServiceTypes,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
    fromDate:
      period === "Flex Period"
        ? format(fromDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
    toDate:
      period === "Flex Period"
        ? format(toDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
  });

  const { data: citProcessedCash } = useGetCitProcessedCash({
    period,
    routeNo,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    serviceType: ddlServiceTypes,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
    fromDate:
      period === "Flex Period"
        ? format(fromDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
    toDate:
      period === "Flex Period"
        ? format(toDate, "yyyy-MM-dd'T'00:00:00.000'Z'")
        : null,
  });

  const { data: vaultStatusData } = useGetVaultStatus({
    period,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    currentDate: format(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    ),
  });

  const { data: vansStatus = [] } = useGetVansStatus({
    period,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
  });

  const { data: dispatchedVansData = [] } = useGetDispatchedVans({
    period,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
  });

  const { data: endOfDayProgress } = useGetEndOfDayProgress({
    period,
    cashCenterId: ddlCashCenters,
    currency: ddlCurrencies,
    customerId: ddlCustomers,
    currentDate: format(currentDate, "yyyy-MM-dd'T'00:00:00.000'Z'"),
  });

  useEffect(() => {
    if (atmServices.length) {
      const netTotal = atmServices.reduce((p, c) => p + c.total, 0);

      if (parseInt(netTotal) > 0) {
        const netCompleted = atmServices.reduce((p, c) => p + c.completed, 0);

        const completedPercent =
          (parseInt(netCompleted) / parseInt(netTotal)) * 100;

        const routedPercent = completedPercent.toFixed(2);

        setAtmServicesHealth(routedPercent);
      }
    } else {
      setAtmServicesHealth("0");
    }
  }, [atmServices]);

  useEffect(() => {
    if (citServices.length) {
      const netTotal = citServices.reduce((p, c) => p + c.total, 0);

      if (parseInt(netTotal) > 0) {
        const netCompleted = citServices.reduce((p, c) => p + c.completed, 0);

        const completedPercent =
          (parseInt(netCompleted) / parseInt(netTotal)) * 100;

        const routedPercent = completedPercent.toFixed(2);

        setCitServicesHealth(routedPercent);
      }
    } else {
      setCitServicesHealth("0");
    }
  }, [citServices]);

  useEffect(() => {
    if (atmProcessedCash?.result.length) {
      const { result } = atmProcessedCash;

      const atmCashGrid: any = [];

      result.forEach((res: any) => {
        const { data } = res;

        if (res.name === "Notes") {
          data.forEach((d: any) => {
            const obj = {
              category: d.category,
              notes: d.value,
              amount: 0,
            };
            atmCashGrid.push(obj);
          });
        }

        if (res.name === "Amount") {
          data.forEach((d: any) => {
            const typeFound = atmCashGrid.find(
              (cg: any) => cg.category === d.category
            );

            if (typeFound) {
              typeFound.amount = `${d.value.toFixed(3)} M`;

              const itemToRemove = atmCashGrid.findIndex(
                (cg: any) => cg.category === d.category
              );

              atmCashGrid.splice(itemToRemove, 1, typeFound);
            }
          });
        }
      });

      const notes = atmCashGrid.reduce((p: any, c: any) => p + c.notes, 0);
      setAtmNotes(notes);
    }
  }, [atmProcessedCash]);

  useEffect(() => {
    if (citProcessedCash?.result.length) {
      const { noOfOrders, result } = citProcessedCash;

      setCitCashProcessedOrders(noOfOrders);

      const citCashGrid: any = [];

      result.forEach((res) => {
        const { data } = res;

        if (res.name === "Notes") {
          data.forEach((d: any) => {
            const obj = {
              category: d.category,
              notes: d.value,
              amount: 0,
            };
            citCashGrid.push(obj);
          });
        }

        if (res.name === "Amount") {
          data.forEach((d: any) => {
            const typeFound = citCashGrid.find(
              (cg: any) => cg.category === d.category
            );

            if (typeFound) {
              typeFound.amount = `${d.value.toFixed(3)} M`;

              const itemToRemove = citCashGrid.findIndex(
                (cg: any) => cg.category === d.category
              );

              citCashGrid.splice(itemToRemove, 1, typeFound);
            }
          });
        }
      });

      setCitProcessedCashGrid(citCashGrid);

      const notes = citCashGrid.reduce((p: any, c: any) => p + c.notes, 0);
      setCitNotes(notes);
    }
  }, [citProcessedCash]);

  useEffect(() => {
    if (vaultStatusData) {
      const vaultData = [
        {
          description: "Insurance Limit",
          amount: vaultStatusData.limit.toFixed(3),
          color: "#BB8374",
        },
        {
          description: "Opening Stock",
          amount: vaultStatusData.openingStock.toFixed(3),
          color: "#BB8374",
        },
        {
          description: "Cash Out",
          amount: vaultStatusData.cashOut.toFixed(3),
          color: "#F66311",
        },
        {
          description: "Cash In",
          amount: vaultStatusData.cashIn.toFixed(3),
          color: "#F0B8AA",
        },
        {
          description: "Closing Balance",
          amount: vaultStatusData.closingStock.toFixed(3),
          color: "#F77355",
        },
      ];

      setVaultStatus(vaultData);
    } else {
      setVaultStatus([]);
    }
  }, [vaultStatusData]);

  useEffect(() => {
    if (dispatchedVansData.length) {
      const result: any = dispatchedVansData.map((res) => ({
        routeNo: res.routeNo,
        van: res.van,
        limit: res.insuranceLimit,
        cash: res.currentCash,
      }));

      setDispatchedVans(result);

      setVansCashLimit(result[0].limit);
    }
  }, [dispatchedVansData]);

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
    setOperationDate(currentDate);

    if (!value) {
      setDdlCashCenters("");
      setRouteNo("");
    }
  };

  const onDdlCurrenciesChanged = (value: string) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    setDdlCurrencies(value);
    setOperationDate(currentDate);

    if (!value) {
      setDdlCurrencies("");
    }
  };

  const onDdlCustomersChanged = (value: string) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }
    setDdlCustomers(value);
    setOperationDate(currentDate);
  };

  const onRouteNoChanged = (value: string) => {
    setRouteNo(value);

    if (!value) {
      setRouteNo("");
    }
  };

  const onDdlLocationTypesChanged = (value: string) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    setDdlLocationTypes(value);
    setOperationDate(currentDate);

    if (!value) {
      setDdlLocationTypes("");
    }
  };

  const onDdlServiceTypesChanged = (value: string) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }
    setDdlServiceTypes(value);
    setOperationDate(currentDate);
    if (!value) {
      setDdlServiceTypes("");
    }
  };

  const togglePeriod: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    const option = (e.target as unknown as { id: string }).id;

    setOperationDate(currentDate);

    if (option === "today") {
      setPeriod("Today");
      setShowFlexPeriod(false);
    }

    if (option === "week") {
      setPeriod("Last Week");
      setShowFlexPeriod(false);
    }

    if (option === "month") {
      setPeriod("Last Month");
      setShowFlexPeriod(false);
    }

    if (option === "flex") {
      setPeriod("Flex Period");
      setShowFlexPeriod(true);
    }
  };

  const onTxtOpsDateChanged = (value: Date) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (value) {
      setOperationDate(value);
    }
  };

  const txtFromDateChanged = (value: Date) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (value) {
      setFromDate(value);
      if (toDate && toDate.getDate() < value.getDate()) {
        showToast("error", "To date can not be less than from date.");
      }
    }
  };

  const txtToDateChanged = (value: Date) => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    if (value) {
      setToDate(value);

      if (fromDate && value.getDate() < fromDate.getDate()) {
        showToast("error", "To date can not be less than from date.");
      }
    }
  };

  const toggleAtmChartView = () => {
    setShowAtmServiceChart(!showAtmServiceChart);
  };

  const toggleCitChartView = () => {
    setShowCitServiceChart(!showCitServiceChart);
  };

  const toggleCitCashChartView = () => {
    setShowCitCashChart(!showCitCashChart);
  };

  const toggleVaultChartView = () => {
    setShowVaultStatusChart(!showVaultStatusChart);
  };

  const toggleVansChartView = () => {
    setShowVansChart(!showVansChart);
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>SMT Dashboard</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="mt-5 mx-4 pb-5">
        <Card>
          <CardContent className="p-2">
            <div className="flex gap-4">
              <div className="w-[50%] flex gap-2">
                <Combobox
                  value={ddlCashCenters}
                  data={cashCenterList?.map((item) => ({
                    value: item.cashCenterId,
                    label: item.name,
                  }))}
                  placeholder="Cash Center"
                  setValue={onDdlCashCentersChanged}
                />

                <Combobox
                  value={ddlCurrencies}
                  data={currencyList?.map((item: any) => ({
                    value: item.shortName,
                    label: item.name,
                  }))}
                  placeholder="Currencies"
                  setValue={onDdlCurrenciesChanged}
                />

                <Combobox
                  value={ddlCustomers}
                  data={customerList?.map((item) => ({
                    value: item.customerId,
                    label: item.name,
                  }))}
                  placeholder="Customer"
                  setValue={onDdlCustomersChanged}
                />

                <Combobox
                  value={routeNo}
                  data={routes?.map((item: any) => ({
                    value: item?.routeNo,
                    label: `${item?.routeDescription} (${item?.routeNo})`,
                  }))}
                  placeholder="Route No."
                  setValue={onRouteNoChanged}
                />
              </div>
              <div className="flex flex-1 gap-2">
                {showFlexPeriod ? (
                  <>
                    <DatePicker
                      placeholder="From Date"
                      selectedDate={fromDate}
                      onSelectDate={txtFromDateChanged}
                    />

                    <DatePicker
                      placeholder="To Date"
                      selectedDate={toDate}
                      onSelectDate={txtToDateChanged}
                    />
                  </>
                ) : null}
              </div>
              <div className="flex gap-2">
                <Button
                  variant={period === "Today" ? "default" : "secondary"}
                  id="today"
                  onClick={togglePeriod}
                >
                  Today
                </Button>

                <Button
                  variant={period === "Last Week" ? "default" : "secondary"}
                  id="week"
                  onClick={togglePeriod}
                >
                  Last Week
                </Button>

                <Button
                  variant={period === "Last Month" ? "default" : "secondary"}
                  id="month"
                  onClick={togglePeriod}
                >
                  Last Month
                </Button>

                <Button
                  variant={period === "Flex Period" ? "default" : "secondary"}
                  id="flex"
                  onClick={togglePeriod}
                >
                  Flex Period
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="flex gap-2 mt-3">
          <Card className="w-[40%] text-center">
            <CardContent className="p-4">
              <div className="flex gap-2">
                <h3 className="font-semibold text-lg text-center">
                  ATM Services
                </h3>
                <Combobox
                  value={ddlLocationTypes}
                  data={locationTypes}
                  placeholder="Location Type"
                  setValue={onDdlLocationTypesChanged}
                />

                <Button
                  variant="secondary"
                  onClick={toggleAtmChartView}
                  className="btn btn-outline-icon me-auto"
                >
                  <List />
                </Button>
              </div>

              {showAtmServiceChart ? (
                <ColumnViewChart data={atmServices} />
              ) : (
                <ATMServicesGrid data={atmServices} />
              )}
            </CardContent>
          </Card>

          <Card className="w-[20%]  text-center">
            <CardContent className="p-2">
              <RadialGaugeViewChart value={Number(atmServicesHealth)} />
              <span className="text-primary-darken-3 h6">
                {`ATM Operations' Health`}
              </span>

              <RadialGaugeViewChart value={Number(citServicesHealth)} />
              <span className="text-primary-darken-3 h6">
                {`CIT Operations' Health`}
              </span>
            </CardContent>
          </Card>

          <Card className="w-[40%] text-center">
            <CardContent className="p-4">
              <div className="flex gap-2">
                <h3 className="font-semibold text-lg text-center">
                  CIT Services
                </h3>
                <Combobox
                  value={ddlServiceTypes}
                  data={serviceTypes}
                  placeholder="Service Type"
                  setValue={onDdlServiceTypesChanged}
                />
                <Button
                  variant="secondary"
                  onClick={toggleCitChartView}
                  className="btn btn-outline-icon me-auto"
                >
                  <List />
                </Button>
              </div>

              {showCitServiceChart ? (
                <ColumnViewChart data={citServices} />
              ) : (
                <ATMServicesGrid data={citServices} />
              )}
            </CardContent>
          </Card>
        </div>

        <div className="flex gap-2 mt-3">
          <Card className="flex-1">
            <CardContent className="p-4">
              <div className="flex justify-between">
                <h3 className="font-semibold text-lg text-center">
                  {`CIT Cash Processing (${citCashProcessedOrders} services)`}
                </h3>
                <Button variant="secondary" onClick={toggleCitCashChartView}>
                  <List />
                </Button>
              </div>

              {showCitCashChart ? (
                citProcessedCash?.result ? (
                  <MultiSeriesDonutViewChart
                    data={[...citProcessedCash.result]}
                  />
                ) : null
              ) : (
                <div className="mt-4">
                  <ProcessedCashGrid data={citProcessedCashGrid} />
                </div>
              )}
            </CardContent>
          </Card>
          <Card className="flex-1">
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg text-center">
                Overall Cash Processing
              </h3>
              <DonutViewChart
                data={[
                  {
                    status: "Total Notes",
                    count: atmNotes + citNotes,
                    color: "#BB8374",
                  },
                  { status: "ATM Notes", count: atmNotes, color: "#F66311" },
                  { status: "CIT Notes", count: citNotes, color: "#F0B8AA" },
                ]}
                percent="ATM Cash Processing"
                showCenterLabel={false}
                showLengend={false}
              />
            </CardContent>
          </Card>
          <Card className="flex-1">
            <CardContent className="p-4">
              <div className="flex justify-between gap-2">
                <h3 className="font-semibold text-lg text-center">
                  Vault Status
                </h3>
                <DatePicker
                  placeholder="Operation Date"
                  selectedDate={operationDate}
                  onSelectDate={onTxtOpsDateChanged}
                />
                <Button variant="secondary" onClick={toggleVaultChartView}>
                  <List />
                </Button>
              </div>
              {showVaultStatusChart ? (
                <BarViewChart data={vaultStatus} />
              ) : (
                <VaultStatusGrid data={vaultStatus} />
              )}
            </CardContent>
          </Card>

          <Card className="flex-1">
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg text-center">
                End of Day Progress
              </h3>
              <ServicesCompletionViewChart value={endOfDayProgress || 0} />
            </CardContent>
          </Card>
        </div>

        <div className="flex gap-2 mt-3">
          <Card className="w-[25%]">
            <CardContent className="p-4">
              <div className="flex justify-between">
                <h3 className="font-semibold text-lg text-center">
                  Cash Vans Availability
                </h3>
                <Button variant="secondary" onClick={toggleVansChartView}>
                  <List />
                </Button>
              </div>
              {showVansChart ? (
                <DonutViewChart data={[...vansStatus]} />
              ) : (
                <VansStatusGrid data={vansStatus} />
              )}
            </CardContent>
          </Card>
          <Card className="w-[75%]">
            <CardContent className="p-4">
              <h3 className="font-semibold text-lg text-center">
                Cash Vans Insurance Tracker
              </h3>

              <VanCashLimitViewChart
                data={dispatchedVans}
                vanInsuranceLimit={vansCashLimit}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}

export default SMTDashboardPage;
